import React, { Component } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  Input,
  Container,
  Col,
  Row,
  Button,
} from "reactstrap";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getContacts } from "../../store/contactUs/actions";
import { withRouter } from "react-router-dom";

class ContactUs extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.getContacts();
  }

  renderContactUsInformation() {
    const { contacts } = this.props;

    return (
      <div>
        {contacts.map((contact) => {
          return (
            <Row className="mt-3">
              <Col md="6" lg="6">
                {`Nombre: ${contact.name}`}
              </Col>
              <Col md="6" lg="6">
                {`Teléfono: ${contact.cellphone}`}
              </Col>
            </Row>
          );
        })}
        <Row className="mt-3"></Row>
        <Row className="mt-3">
          <Col>
            <Button
              color="secondary"
              onClick={() => this.props.history.push("/")}
            >
              Regresar
            </Button>
          </Col>
        </Row>
      </div>
    );
  }

  render() {
    return (
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="2" lg="3" />
            <div className="col-md-8 col-lg-6">
              <Card>
                <CardHeader>Contactos</CardHeader>
                <CardBody style={{ paddingBottom: "10px" }}>
                  {this.renderContactUsInformation()}
                </CardBody>
              </Card>
            </div>
            <Col md="2" lg="3" />
          </Row>
        </Container>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { contacts, error, loading } = state.contactUs.contactUsList;

  return {
    contacts,
    error,
    loading,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getContacts,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ContactUs));



// WEBPACK FOOTER //
// ./src/scenes/ContactUs/ContactUs.js